import { useMemo } from 'react';
import { MovieStreamFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useCurrentStream as useCurrentKpPlayerStream } from '@/scenarios/legacy-player/hooks/useCurrentStream';

const getComparableStreamUrl = (streamUrl: string | undefined) => {
    const url = (streamUrl && new URL(streamUrl)) || null;
    return url && `${url.hostname}${url.pathname}`;
};

export const useCurrentStream = <Stream extends Pick<MovieStreamFragment, 'uri'>>(
    streams: (Stream | null | undefined)[] | undefined | null
): Stream | null => {
    const { url: streamUrl } = useCurrentKpPlayerStream() || {};

    return useMemo(
        () =>
            streams?.find(
                (stream) =>
                    getComparableStreamUrl(stream?.uri) === getComparableStreamUrl(streamUrl)
            ) ?? null,
        [streamUrl, streams]
    );
};
